var moduleMap = {
	"./react": () => {
		return __webpack_require__.e(2471).then(() => (() => ((__webpack_require__(62471)))));
	},
	"./formik": () => {
		return __webpack_require__.e(9074).then(() => (() => ((__webpack_require__(59074)))));
	},
	"./react-dom": () => {
		return __webpack_require__.e(7711).then(() => (() => ((__webpack_require__(37711)))));
	},
	"./styled-components": () => {
		return __webpack_require__.e(3153).then(() => (() => ((__webpack_require__(53153)))));
	},
	"./AuthContext": () => {
		return __webpack_require__.e(3643).then(() => (() => ((__webpack_require__(83643)))));
	},
	"./typeDetail": () => {
		return __webpack_require__.e(8411).then(() => (() => ((__webpack_require__(88411)))));
	},
	"./PreferencesContext": () => {
		return __webpack_require__.e(8124).then(() => (() => ((__webpack_require__(68124)))));
	},
	"./Autocomplete": () => {
		return __webpack_require__.e(7521).then(() => (() => ((__webpack_require__(67521)))));
	},
	"./SitemapContext": () => {
		return __webpack_require__.e(3778).then(() => (() => ((__webpack_require__(23778)))));
	},
	"./FormattersContext": () => {
		return __webpack_require__.e(4626).then(() => (() => ((__webpack_require__(34626)))));
	},
	"./SignalRContext": () => {
		return __webpack_require__.e(6384).then(() => (() => ((__webpack_require__(26384)))));
	},
	"./PluginContext": () => {
		return __webpack_require__.e(3951).then(() => (() => ((__webpack_require__(3951)))));
	},
	"./PluginFormContext": () => {
		return __webpack_require__.e(6521).then(() => (() => ((__webpack_require__(6521)))));
	},
	"./TabContext": () => {
		return __webpack_require__.e(7662).then(() => (() => ((__webpack_require__(17662)))));
	},
	"./ModalContext": () => {
		return __webpack_require__.e(6762).then(() => (() => ((__webpack_require__(56762)))));
	},
	"./SidebarContext": () => {
		return __webpack_require__.e(6902).then(() => (() => ((__webpack_require__(56902)))));
	},
	"./ContextMenuContext": () => {
		return __webpack_require__.e(7083).then(() => (() => ((__webpack_require__(37083)))));
	},
	"./Formatters": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(6810), __webpack_require__.e(201), __webpack_require__.e(4108), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(3153), __webpack_require__.e(8124), __webpack_require__.e(3351), __webpack_require__.e(7711), __webpack_require__.e(9074), __webpack_require__.e(7662), __webpack_require__.e(6762), __webpack_require__.e(6902), __webpack_require__.e(4558), __webpack_require__.e(3643), __webpack_require__.e(6384), __webpack_require__.e(7083), __webpack_require__.e(8411), __webpack_require__.e(1148), __webpack_require__.e(7521), __webpack_require__.e(3778), __webpack_require__.e(3951), __webpack_require__.e(4626), __webpack_require__.e(3999), __webpack_require__.e(5011), __webpack_require__.e(2580), __webpack_require__.e(5115)]).then(() => (() => ((__webpack_require__(83171)))));
	},
	"./entityDetail": () => {
		return __webpack_require__.e(1148).then(() => (() => ((__webpack_require__(21148)))));
	},
	"./entityActions": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(201), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(1953)]).then(() => (() => ((__webpack_require__(41953)))));
	},
	"./entityList": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(201), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(6384), __webpack_require__.e(2580), __webpack_require__.e(4168)]).then(() => (() => ((__webpack_require__(2580)))));
	},
	"./dataFilter": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(2283)]).then(() => (() => ((__webpack_require__(32283)))));
	},
	"./data": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(201), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(9095)]).then(() => (() => ((__webpack_require__(99095)))));
	},
	"./uiToolkit": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(6810), __webpack_require__.e(201), __webpack_require__.e(4108), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(3153), __webpack_require__.e(8124), __webpack_require__.e(3351), __webpack_require__.e(7711), __webpack_require__.e(9074), __webpack_require__.e(7662), __webpack_require__.e(6762), __webpack_require__.e(6902), __webpack_require__.e(4558), __webpack_require__.e(3999)]).then(() => (() => ((__webpack_require__(79404)))));
	},
	"./uiToolkitV2": () => {
		return Promise.all([__webpack_require__.e(8784), __webpack_require__.e(3983), __webpack_require__.e(6810), __webpack_require__.e(201), __webpack_require__.e(4108), __webpack_require__.e(2471), __webpack_require__.e(7451), __webpack_require__.e(3153), __webpack_require__.e(8124), __webpack_require__.e(3351), __webpack_require__.e(7711), __webpack_require__.e(9074), __webpack_require__.e(7662), __webpack_require__.e(6762), __webpack_require__.e(6902), __webpack_require__.e(4558), __webpack_require__.e(3999)]).then(() => (() => ((__webpack_require__(20218)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});